



































































































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

import SelectStadium from "@/components/selectstadium.vue";

@Component({
  components: {
    SelectStadium
  }
})
export default class extends Mixins(MyList) {
  dispatchType: string = "stadiumcrm/list";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "场馆名称", dataIndex: "stadium_name" },
    { title: "添加时间", dataIndex: "created_time" },
    { title: "名称", dataIndex: "name" },
    { title: "手机号", dataIndex: "mobile" },
    { title: "工作时间", scopedSlots: { customRender: "work_time" } },
    { title: "薪资", dataIndex: "salary" },
    { title: "删除状态", scopedSlots: { customRender: "is_delete" } }
  ];

  // 操作搜索栏的展开和折叠
  isFlag = false;


  mounted() {
    this.loadData();
  }

  renderWorkTime(work_time: string): any {
    const obj: any = JSON.parse(work_time);
    let tstr: string = "";
    for (const row of obj) {
      tstr += `<div>${this.renderWeek1(row.week)}，${row.start}-${row.end}</div>`;
    }

    return tstr;
  }

  renderWeek1(weekArr: any[]) {
    let str: string[] = [];
    for (const row of this.weeks) {
      if (weekArr.includes(row.key)) {
        str.push(row.name);
      }
    }
    return str.join(",");
  }
}
